<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    :elevation="$vuetify.theme.dark ? 9 : 8"
    content-class="list-style notification-menu-content"
    :min-width="$vuetify.breakpoint.smAndUp ? '325' : '205'"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <v-badge
          v-if="pendingGmailNotifications > 0"
          bottom
          color="primary"
          overlap
          offset-x="26"
          offset-y="10"
          dot
        >
          <v-icon
            class="mr-4"
            @click="fetchNotifications()"
          >
            {{ icons.mdiBellOutline }}
          </v-icon>
        </v-badge>

        <v-icon
          v-else
          @click="fetchNotifications()"
          class="mr-4"
        >
          {{ icons.mdiBellOutline }}
        </v-icon>
      </div>
    </template>
    <v-card class="app-bar-notification-content-container">
      <v-list class="py-0">
        <!-- Header -->
        <v-list-item class="d-flex">
          <div class="d-flex align-center justify-space-between flex-grow-1">
            <v-chip
              class="v-chip-light-bg primary--text font-weight-semibold"
              small
            >
              {{ notifications.length }} New Mail
            </v-chip>
            <small
              class="font-weight-medium cursor-pointer"
              @click="markAsRead()"
              v-if="notifications.length > 0 && !readLoading"
            >
              Mark all as read
            </small>
          </div>
        </v-list-item>
        <v-divider></v-divider>

        <div class="notification-list-scroll">
          <!-- Notifications -->
          <template
            v-for="(notification, index) in notifications"
          >
            <v-tooltip left :key="notification.title + '-tooltip'">
              <template #activator="{ on, attrs }">
                <v-list-item
                  v-bind="attrs"
                  v-on="on"
                  :key="notification.title"
                >
                  <v-icon color="primary" class="mr-4">{{ icons.mdiGmail }}</v-icon>

                  <!-- Content -->
                  <v-list-item-content class="d-block notification-item-content">
                    <v-list-item-title class="text-sm font-weight-semibold">
                      {{ notification.from }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-sm">
                      {{ notification.subject }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ notification.inbox_email }}</span>
            </v-tooltip>
            <v-divider
              :key="index"
            ></v-divider>
          </template>
        </div>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import store from '@/store'
import {
  ref,
  inject,
  computed,
} from '@vue/composition-api'
import { mdiBellOutline, mdiGmail } from '@mdi/js'

export default {
  components: {
  },
  setup() {
    const snackbarService = inject('snackbarService')
    const fetchLoading = ref(false)
    const readLoading = ref(false)

    const notifications = ref([])

    const fetchNotifications = () => {
      fetchLoading.value = true
      store
        .dispatch('fetchGmailNotifications')
        .then(response => {
          notifications.value = response.data.data
          fetchLoading.value = false
        })
        .catch(error => {
          fetchLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching notifications. Please refresh!')
        })
    }
    const fetchPendingGmailNotifications = () => {
      store
        .dispatch('fetchPendingGmailNotifications')
        .then(response => {
          const { data } = response.data
          store.dispatch('setPendingGmailNotifications', data)
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching pending gmail notifications. Please refresh!')
        })
    }

    const markAsRead = () => {
      readLoading.value = true
      store
        .dispatch('markGmailAsRead')
        .then(response => {
          readLoading.value = false
          snackbarService.success(response.data.message)
          fetchPendingGmailNotifications()
          fetchNotifications()
        })
        .catch(error => {
          readLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while marking notifications. Please refresh!')
        })
    }

    const pendingGmailNotifications = computed(() => store.state.pendingGmailNotifications)

    return {
      notifications,
      fetchNotifications,
      markAsRead,
      readLoading,
      pendingGmailNotifications,

      icons: {
        mdiBellOutline,
        mdiGmail,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.notification-list-scroll {
  max-height: 400px;
  overflow-y: auto;
}
.notification-item-content {
  max-width: 250px;
}
.notification-item-content .v-list-item__title,
.notification-item-content .v-list-item__subtitle {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
